import styled from 'styled-components'
import { Link } from 'react-router-dom'

const Cell = styled(Link)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 190px;
  padding: 22px 24px 20px;
  background: #1d2c33;
  border: 1px solid rgba(201, 184, 151, 0.18);
  text-decoration: none;
  transition: background-color 0.25s ease,
              border-color 0.25s ease,
              transform 0.3s cubic-bezier(0.2, 0.8, 0.2, 1),
              box-shadow 0.3s ease;

  &:hover,
  &:focus-visible {
    background: #24363f;
    border-color: #c9b897;
    transform: translateY(-2px);
    box-shadow: 0 8px 22px rgba(16, 27, 33, 0.25);
    outline: none;
  }

  @media (max-width: 768px) {
    min-height: 150px;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: background-color 0.25s ease, border-color 0.25s ease;
    &:hover,
    &:focus-visible {
      transform: none;
    }
  }
`;

const TopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Code = styled.span`
  font-family: 'Rubik', sans-serif;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.22em;
  color: #8d7e62;
  transition: color 0.25s ease;

  ${Cell}:hover &,
  ${Cell}:focus-visible & {
    color: #c9b897;
  }
`;

const Arrow = styled.span`
  width: 28px;
  height: 28px;
  border: 1px solid rgba(201, 184, 151, 0.4);
  border-radius: 50%;
  display: grid;
  place-items: center;
  color: #c9b897;
  font-size: 13px;
  transition: all 0.25s ease;

  ${Cell}:hover &,
  ${Cell}:focus-visible & {
    background: #c9b897;
    border-color: #c9b897;
    color: #1d2c33;
    transform: translateX(2px);
  }
`;

const TextBlock = styled.div``;

const Title = styled.h3`
  margin: 0 0 8px 0;
  font-family: 'Source Serif 4', Georgia, serif;
  font-size: 29px;
  font-weight: 600;
  letter-spacing: -0.01em;
  line-height: 1.05;
  color: #e2cfa8;
  transition: color 0.25s ease;

  ${Cell}:hover &,
  ${Cell}:focus-visible & {
    color: #f0dcb4;
  }

  @media (max-width: 768px) {
    font-size: 25px;
  }
`;

const Tagline = styled.p`
  margin: 0;
  font-size: 12.5px;
  font-weight: 300;
  line-height: 1.5;
  color: rgba(247, 245, 240, 0.68);
  max-width: 36ch;
  transition: color 0.25s ease;

  ${Cell}:hover &,
  ${Cell}:focus-visible & {
    color: rgba(247, 245, 240, 0.85);
  }
`;

function HomeSectionCard(props) {
  return (
    <Cell to={props.link}>
      <TopRow>
        <Code>{props.code}</Code>
        <Arrow>&rarr;</Arrow>
      </TopRow>
      <TextBlock>
        <Title>{props.title}</Title>
        <Tagline>{props.tagline}</Tagline>
      </TextBlock>
    </Cell>
  );
}

export default HomeSectionCard;
